/* Publish by EComposer at 2024-06-07 00:21:57*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-pbb7s6xzz9f"]=  window.__ectimmers["ecom-pbb7s6xzz9f"] || {};
if(!this.$el)return;const e=this.$el,i=e.querySelector(".ecom-text_view-more-btn"),t=e.querySelector(".ecom-text_view-less-btn"),n=e.querySelector(".text-content.ecom-html");!n||(i&&i.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",i.style.display="none",t.style.display=""}),t&&t.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",t.style.display="none",i.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-pbb7s6xzz9f').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pbb7s6xzz9f', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gwjv0ph6ov').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gwjv0ph6ov', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gdmoelhtu2').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gdmoelhtu2', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4i20j2fz6j6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4i20j2fz6j6', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-twmeszofxx').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-twmeszofxx', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rcxxfipzj2o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rcxxfipzj2o', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bd96enhgf6c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bd96enhgf6c', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-25r7fggtl47').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-25r7fggtl47', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-s85vrkdh1p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-s85vrkdh1p', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qtxyuoq5c9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qtxyuoq5c9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fa5beay6i6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fa5beay6i6', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-h7rzhyndecc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-h7rzhyndecc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-951jphwj60b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-951jphwj60b', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7wfq63jdo6a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7wfq63jdo6a', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dnwh2m066li').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dnwh2m066li', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9ws6qu3tp4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9ws6qu3tp4', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hg4ju8pafe').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hg4ju8pafe', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-13k51vr9rmue').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-13k51vr9rmue', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hage4mhb8ke').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hage4mhb8ke', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mpqn3zu3cp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mpqn3zu3cp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-b2pykpceeq8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-b2pykpceeq8', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-51mehjbl1sk"]=  window.__ectimmers["ecom-51mehjbl1sk"] || {};
let e=this.$el;if(!e)return;let i=e.querySelectorAll(":scope > .tabs__wrapper > .tabs__navs > .tabs__navs--items > .tabs__nav"),t=e.querySelectorAll(":scope > .tabs__wrapper > .core__group--items > .tab__item"),n=this.settings.action;i.forEach((r,a)=>{n==="click"||window.screen.width<1025?r.onclick=function(){this.classList&&this.classList.contains("ecom-item-active")?(i.forEach(c=>c.classList.remove("ecom-item-active")),t.forEach(c=>c.classList.remove("ecom-item-active"))):(i.forEach(c=>c.classList.remove("ecom-item-active")),t.forEach(c=>c.classList.remove("ecom-item-active")),r.classList.add("ecom-item-active"),t[a].classList.add("ecom-item-active")),o()}:r.onmouseover=function(){this.classList&&this.classList.contains("ecom-item-active")?(i.forEach(c=>c.classList.remove("ecom-item-active")),t.forEach(c=>c.classList.remove("ecom-item-active"))):(i.forEach(c=>c.classList.remove("ecom-item-active")),t.forEach(c=>c.classList.remove("ecom-item-active")),r.classList.add("ecom-item-active"),t[a].classList.add("ecom-item-active")),o()}});function s(){let r=window.location.hash;if(r){let a=e.querySelector(`[data-target="${r}"]`);if(a){a.click();let l=a.getBoundingClientRect().top+window.pageYOffset-window.innerHeight/2;window.scrollTo(0,l)}}}setTimeout(()=>{s()},300);function o(){window.dispatchEvent(new window.Event("resize")),setTimeout(()=>{window.dispatchEvent(new window.Event("resize"))},500)}window.addEventListener("hashchange",s,!1)

                    });
                    
                        document.querySelectorAll('.ecom-51mehjbl1sk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-51mehjbl1sk', settings: {"action":"click"},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}